
const hardwares = [
    {
        label: "All",
        value: '/store/hardware',
    },
    {
        label: "Closers",
        value: '/store/hardware/closers',
    },
    {
        label: "Hinges",
        value: '/store/hardware/hinges',
    },
    {
        label: "Locks",
        value: '/store/hardware/locks',
    },
    {
        label: "Cylinders",
        value: '/store/hardware/cylinders',
    },
    {
        label: "Handles / Finger Plates",
        value: '/store/hardware/handles-finger-plates',
    },
    {
        label: "Letterplates",
        value: '/store/hardware/letterbox',
    },
    {
        label: "Ancillary Items",
        value: '/store/hardware/ancillary-items'
    },
]

const seals = [
    {
        label: "All",
        value: '/store/seal',
    },
    {
        label: "Fire",
        value: '/store/seal/fire',
    },
    {
        label: "Fire & Smoke Seals",
        value: '/store/seal/fire-smoke',
    },
    {
        label: "Acoustic Seals",
        value: '/store/seal/acoustic',
    },
    {
        label: "Seal Kits",
        value: '/store/seal/kits',
    },
    {
        label: "Glazing Seals",
        value: '/store/seal/glazing',
    },
]

const cores = [
    {
        label: "All",
        value: '/store/core',
    },
    {
        label: "3-Layer Particle Board",
        value: '/store/core/3-layer-particle-boards',
    },
    {
        label: "Solid Timber Core",
        value: '/store/core/solid-timber-cores',
    },
    {
        label: "Mineral Core",
        value: '/store/core/mineral-cores',
    },
]

const smartTags = [
    {
        label: "All",
        value: '/store/smart-tags',
    },
]

const signage = [
    {
        label: "All",
        value: '/store/smart-tags',
    },
]

const other_products = [
    {
        label: "All",
        value: '/store/others',
    },
    {
        label: "Closer Protection",
        value: '/store/closer-protection',
    },
    {
        label: "Hinge Protection",
        value: '/store/hinge-protection',
    },
    {
        label: "Lock Protection",
        value: '/store/lock-protection',
    },
    {
        label: "Air Transfer Grill",
        value: '/store/air-transfer-grill',
    },
    {
        label: "Accessories",
        value: '/store/accessories',
    },
]

let shopLinks = {
    hardwares,
    seals,
    cores,
    signage,
    smartTags,
    other_products
}

export default shopLinks